"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.useInitializeTooltips = useInitializeTooltips;
var _react = require("react");
// libraries

function useInitializeTooltips(JQuery) {
  (0, _react.useEffect)(function () {
    // intialize bootstrap/popper tooltips
    JQuery('[data-toggle="tooltip"]').tooltip();

    // ensure that all tooltips are hidden when component UnMounts
    return function () {
      JQuery('[data-toggle="tooltip"]').tooltip('hide');
    };
  }, []);
}
var _default = useInitializeTooltips;
exports.default = _default;